import { StyleSheet, TextInput, View } from 'react-native'
import React, { useRef, useState } from 'react'
import { countryCodes } from '@libs/utils'
import { useTheme } from '@libs/theme'
import SearchDropDown from '../DropDown/SearchDropdown'

const MobileInput = ({
  inputFieldStyle,
  placeholder,
  placeholderColor,
  dialCode,
  value,
  style,
  code,
  maxLength,
  onChangeText = () => {},
  handleCountrySelection = () => {},
  countryBasedOn,
  searchDropDownBackgroundColor,
}) => {
  const { colors } = useTheme()
  const [dropdownTop, setDropdownTop] = useState(0)
  const [dropdownLeft, setDropdownLeft] = useState(0)
  const [dropdownWidth, setDropDownWidth] = useState(0)
  const dropDownRef = useRef()

  const toggleDropdown = (visible) => {
    if (visible) {
      return
    }
    if (!visible) {
      dropDownRef?.current?.measureInWindow?.((x, y, width, height) => {
        setDropdownTop(y + height + 4)
        setDropdownLeft(x)
        setDropDownWidth(width)
      })
    }
  }

  return (
    <View
      style={[
        styles.inputContainer,
        {
          borderColor: style?.borderColor || colors.primaryPlaceHolder,
          borderRadius: 4,
          height: style?.height,
        },
        style,
      ]}
      ref={dropDownRef}
    >
      <SearchDropDown
        items={countryCodes}
        hasNoBorder
        toggleDropdown={toggleDropdown}
        position={{ left: dropdownLeft, top: dropdownTop }}
        dropdownWidth={dropdownWidth}
        dropdownHeight={200}
        onPress={(selectedFilter) => handleCountrySelection(selectedFilter)}
        isCountryCode
        dialCode={dialCode}
        code={code}
        countryBasedOn={countryBasedOn}
        searchDropDownBackgroundColor={searchDropDownBackgroundColor}
      />
      <TextInput
        inputMode="tel"
        placeholder={placeholder}
        style={[
          styles.inputField,
          inputFieldStyle,
          { borderRadius: 12 },
          style,
        ]}
        placeholderTextColor={placeholderColor || colors.primaryPlaceHolder}
        onChangeText={(text) => {
          const normalizedText = `${text || ''}`.replace(/\D/g, '')
          onChangeText(normalizedText)
        }}
        keyboardType="numeric"
        maxLength={maxLength}
        value={value}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  inputContainer: {
    borderWidth: 1,
    borderRadius: 4,
    height: 56,
    marginBottom: 10,
    flexDirection: 'row',
    overflow: 'hidden',
  },
  inputField: {
    flex: 1,
    marginLeft: 10,
  },
})

export default MobileInput
